import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "projectPanel" }
const _hoisted_2 = { class: "thumbnailCard" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { style: {"padding-left":"0","padding-top":"0","padding-right":"0.5rem","padding-bottom":"0.25rem","overflow":"hidden"} }
const _hoisted_5 = {
  class: "projectTitle",
  style: {"font-weight":"700","margin-bottom":"0"}
}
const _hoisted_6 = { class: "thumbnail-wrap" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "thumbnail-no-image"
}
const _hoisted_9 = { class: "projectDescription" }
const _hoisted_10 = {
  key: 0,
  class: "userBlockWrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserBlockSmall = _resolveComponent("UserBlockSmall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.onclickURL,
        class: "projectPanelLink",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickProject && _ctx.onClickProject(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.publicPage.title ? _ctx.publicPage.title : '(タイトル未設定)'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.hasImage && _ctx.urls.getThumbnailURL(_ctx.publicPage.user.id, _ctx.publicPage))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "card-img-top thumbnail",
                style: {"border-radius":"0","border":"1px solid #999"},
                src: _ctx.urls.getThumbnailURL(_ctx.publicPage.user.id, _ctx.publicPage),
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
              }, null, 40, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, " no image "))
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.shortDescrition), 1)
      ], 8, _hoisted_3),
      (_ctx.publicPage.user != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_UserBlockSmall, {
              dtoUser: _ctx.publicPage.user
            }, null, 8, ["dtoUser"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}